<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu>
        <li class="divider"></li>
      </mobile-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content 
        @click="toggleSidebar">
      </dashboard-content>
      <footer>
        <div class="flex-row footer-container">
          <div class="flex-column company-container">
            <div class="logo">
              <!--<svg-icon-container
                class="flex-left logo"
                focusable="false" 
                :icon="'hseAllianceIcon'">
              </svg-icon-container>-->
              <span class="flex-left logo logo-text">HERMERTIA WARS</span>
            </div>
            <div class="flex-row social-container">
              <a href="https://discord.gg/JRr94kzk4w">
                <svg class="social" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72">
                  <title>Discord</title>
                  <path d="M54.657,19.077c0,0,8.343,9.663,8.343,27.069v3.65c0,0-10.536,6.866-13.747,6.866l-3.115-4.529	c1.936-0.867,4.577-2.372,4.577-2.372l-0.965-0.747c0,0-6.173,2.86-13.749,2.86s-13.749-2.86-13.749-2.86l-0.965,0.747	c0,0,2.641,1.505,4.577,2.372l-3.115,4.529C19.536,56.662,9,49.796,9,49.796v-3.65c0-17.406,8.343-27.069,8.343-27.069	s5.707-2.762,10.977-3.489l1.635,3.1c0,0,2.599-0.602,6.045-0.602s6.045,0.602,6.045,0.602l1.635-3.1	C48.95,16.315,54.657,19.077,54.657,19.077z M27.01,43.603c2.656,0,4.808-2.418,4.808-5.401c0-2.983-2.153-5.401-4.808-5.401	s-4.808,2.418-4.808,5.401C22.202,41.185,24.354,43.603,27.01,43.603z M44.99,43.603c2.656,0,4.808-2.418,4.808-5.401	c0-2.983-2.153-5.401-4.808-5.401c-2.656,0-4.808,2.418-4.808,5.401C40.182,41.185,42.334,43.603,44.99,43.603z"></path>
                </svg>
              </a>
              <a href="https://soundcloud.com/hermertia-wars-audio">
                <svg class="social" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 425 512"><path d="m317 51q21.5 0 40.5 8.25t33.25 22.5 22.5 33.25 8.25 40.5v209q0 21.5-8.25 40.75t-22.5 33.5-33.25 22.5-40.5 8.25h-209.5q-21.5 0-40.5-8.25t-33.25-22.5-22.5-33.5-8.25-40.75v-209q0-21.5 8.25-40.5t22.5-33.25 33.25-22.5 40.5-8.25zm-224 213q-10.5 9-10.5 22 0 13.5 10.5 21.5zm21.5-6.5h-2.5q-2.5 0-4.25.25t-4.25.75v55q2.5.5 4.25.75t4.25.25h2.5zm22-15q-6.5 8-9 19.5-.5-.5-1-.75t-1-.75v54h11zm21.5-15.5q-3 1-5.75 2.5t-5.25 3v82h11zm22-1.5q-2-.5-3.5-.75t-3.5-.25q-1 0-2 .25t-2 .25v89.5h11zm21.5-1q-1 2-2.5 3.5t-2.5 3q-5.5-3-11-4.5v88h16zm109 90q16-1 23.75-10t7.75-21.5q0-13-8.75-22t-22.25-9q-5.5 0-12 2.5-2.5-20.5-18-34.75t-37-14.25q-11 0-20.25 3.75t-16.75 10.25v95z"/></svg>
              </a>
              <a href="http://hermertia.com">
                <img class="image-micro" src="../../assets/img/HW_Logo_small.png"/>              
              </a>
              <a href="https://www.youtube.com/channel/UCL7im8jz9wEMLyHoZiPoNjQ">
                <svg class="social" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>YouTube</title><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>              
              </a>
            </div>
          </div>
          <div class="footer-nav-container flex-row flex-3">
            <!--<div class="flex-column footer-list">
              <h4>Features</h4>
              <ul class="hi-ul">
                <li>Training Management</li>
                <li>Document Management</li>
              </ul>
            </div>-->
            <div class="flex-column footer-list">
              <h4>Company</h4>
              <ul class="hi-ul">
                <li>
                  <a href="/#about">About Us</a>
                </li>
                <li>
                  <router-link :to="{name: 'Privacy'}">Privacy Agreement</router-link>
                </li>
                <!--<router-link tag="li" :to="''">Terms of Service</router-link>-->
              </ul>
            </div>
          </div>
          <div class="copyright">
            <span>Copyright &copy; {{ todayYear }} Hermertia Studios Cooperative Inc. All rights reserved.</span>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import SvgIconContainer from "../../components/Svg/SvgIconContainer.vue";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
    SvgIconContainer
  },
  computed: {
    isUserPage(){
        return (this.$route.name === 'Organizations' || this.$route.name === 'UserProfile');
    },
    todayYear() {
      const d = new Date();
      return d.getFullYear();
    }  
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false;
      }
    },
  }
};
</script>
